import React, { useEffect, useState } from 'react';
import axios from '../../api/axios';
import ResponsiveTable from "../../components/ResponsiveTable";
import moment from 'moment';
import Select from "react-select";
import Flatpickr from "react-flatpickr";
import jsPDF from 'jspdf';
import 'jspdf-autotable'; // ✅ plugin auto-registers here

function SalesItemProfitSummary() {
  const [data, setData] = useState([]);
  const [start, setStart] = useState(moment().format("YYYY-MM-DD"));
  const [end, setEnd] = useState(moment().add(1, "days").format("YYYY-MM-DD"));
  const [status, setStatus] = useState('all');
  const [totalProfit, setTotalProfit] = useState(0);
  const [totalBill, setTotalBill] = useState(0);

  const fetchData = async () => {
    const res = await axios.get('/reports/sales-items-profit-summary', {
      params: { start, end, status }
    });
    setData(res.data);
    const profit = res.data.reduce((sum, r) => sum + Number(r.total_profit), 0);
    const totalBill = res.data.reduce((sum, r) => sum + Number(r.total_sales), 0);
    setTotalBill(totalBill)
    setTotalProfit(profit)
  };
  const capitalizeFirstLetter = (word) => {
    if (!word || typeof word !== "string") return word;
    return word.charAt(0).toUpperCase() + word.slice(1);
  };
  const exportToPDF = () => {
    const doc = new jsPDF();
    doc.text('Sales Profit per Unit Summary', 14, 10);
    doc.autoTable({
      startY: 20,
      head: [['Date', 'Item', 'Qty', 'Sales', 'Avg Price', 'Purchase Price', 'Profit/Unit', 'Total Profit', 'Status']],
      body: data.map(item => {
        return [
          moment(item.sale_date).format('DD/MM/YYYY'),
          item.item_name,
          item.total_qty,
          parseFloat(item.total_sales).toFixed(2),
          parseFloat(item.avg_sale_price).toFixed(2),
          parseFloat(item.purchase_price).toFixed(2),
          parseFloat(item.profit_per_unit).toFixed(2),
          parseFloat(item.total_profit).toFixed(2),
          item.status
        ];
      })
    });
    doc.save('profit-per-unit-summary.pdf');
  };

  useEffect(() => {
    const today = new Date().toISOString().split('T')[0];
    // setStart(today);
    // setEnd(today);
  }, []);
  const handleAction = (action, row) => {
    if (action === "view") navigate(`/sales/view/${row.id}`);
    if (action === "edit") navigate(`/sales/edit/${row.id}`);
    if (action === "delete") {
      if (window.confirm("Are you sure you want to delete this sale?")) {
        axios.put(`/sales/delete/${row.id}`).then(() => {
          setSales(prev => prev.filter(s => s.id !== row.id));
        });
      }
    }
  };
  const salesOptions = [
    { value: 'all', label: "All" },
    { value: "final", label: "Final" },
    { value: "quotation", label: "Quotation" },
  ];
  const columns = [
    {
      header: "Date", accessor: "sale_date",
      render: (value, row) => <span>{moment(value).format("DD/MM/YYYY")}</span>
    },
    {
      header: "Item Name", accessor: "item_name",
      render: (value, row) => <span>{value}</span>
    },
    {
      header: "Quantity", accessor: "total_qty",
      render: (value, row) => <span className=' flex justify-center font-semibold text-center'>{value}</span>
    },
    {
      header: "Avg Sale Price", accessor: "avg_sale_price",
      render: (value, row) => <span>{(parseFloat(value))?.toFixed(2)} BDT</span>
    },
    {
      header: "Profit per Unit", accessor: "profit_per_unit",
      render: (value, row) => <span>{(parseFloat(value))?.toFixed(2)} BDT</span>
    },
    {
      header: "Total Profit", accessor: "total_profit",
      render: (value, row) => <span>{(parseFloat(value))?.toFixed(2)} BDT</span>
    },
    {
      header: "Total Amount", accessor: "total_sales",
      render: (value, row) => <span className="font-semibold">{(parseFloat(value))?.toFixed(2)} BDT</span>
    },
    {
      header: "Status", accessor: "status",
      render: (value, row) => <span className={`${value === "final" ? " text-green-600 font-semibold" : "text-red-500 font-semibold"}`}>{capitalizeFirstLetter(value)}</span>
    },
  ];
  return (
    <div className="flex">

      <div className="w-full p-6">
        <h2 className="text-xl font-bold mb-4">Sales Item Summery</h2>

        <div className="grid grid-cols-1 md:grid-cols-5 gap-4 mb-4">
          <div className="flex items-center rounded-md">
            <Flatpickr
              style={{
                backgroundColor: "#fff",
                opacity: "1",
                padding: "9px 12px",
              }}
              // options={{
              //   dateFormat: "d-m-Y"
              // }}
              value={start}
              id="date-time-picker"
              className="form-control"
              onChange={(date) => setStart(moment(date[0]).format('YYYY-MM-DD'))}
            />
          </div>
          <div className="flex items-center rounded-md">
            <Flatpickr
              style={{
                backgroundColor: "#fff",
                opacity: "1",
                padding: "9px 12px",
              }}
              // options={{
              //   dateFormat: "d-m-Y"
              // }}
              value={end}
              id="date-time-picker"
              className="form-control"
              onChange={(date) => setEnd(moment(date[0]).format('YYYY-MM-DD'))}
            />
          </div>
          <div className="flex items-center rounded-md">
            <Select
              name="customer"
              onChange={e => setStatus(e.value)}
              options={salesOptions}
              placeholder="Select Sales Type"
              className="w-full"
              classNamePrefix="react-select"
              maxMenuHeight={150}
            />
          </div>
          {/* <input type="date" value={start} onChange={e => setStart(e.target.value)} className="border p-2" />
          <input type="date" value={end} onChange={e => setEnd(e.target.value)} className="border p-2" /> */}
          {/* <select value={status} onChange={e => setStatus(e.target.value)} className="border p-2">
            <option value="all">All</option>
            <option value="final">Final</option>
            <option value="quotation">Quotation</option>
          </select> */}
          <button onClick={fetchData} className="bg-blue-600 text-white px-4 py-0 rounded">Filter</button>
          <button onClick={exportToPDF} className="bg-green-600 text-white px-4 py-0 rounded">Export PDF</button>
        </div>

        <ResponsiveTable
          columns={columns}
          data={data}
          showActions={true}
          onActionClick={handleAction}
        />
        <div className='flex gap-4 max-sm:gap-2 px-2'>
          <p className=' font-bold'>Total Bill: <span className=' text-blue-600'>{totalBill.toFixed(2)}</span></p>
          <p className='font-bold'>Total Profit: <span className=' text-green-600'>{totalProfit.toFixed(2)}</span></p>
        </div>
      </div>
    </div>
  );
}

export default SalesItemProfitSummary;